var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.notification)?_c('v-alert',{staticClass:"ma-3",attrs:{"border":"top","text":"","type":_vm.notification.type,"dismissible":_vm.notification.dismissible}},[_vm._v("\n  "+_vm._s(_vm.notification.message)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }